import React, { useState, useEffect } from "react";
import Button from "./Button";
import ProjectCard from "./ProjectCard/ProjectCard";
import { scroll } from "./Scroll";
import "./Projects.scss";

const CATALOG_URL = `${window.location.origin}/api/catalog.php`;
const ALBUM_URL = `${window.location.origin}/api/album.php`;

export default function Projects() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [albums, setAlbums] = useState([]);

  useEffect(() => {
    loadAlbums();
  }, []);

  async function loadAlbums() {
    try {
      setLoading(true);
      setError(null);

      const mainConfigResponse = await fetch(
        `${CATALOG_URL}?v=${Date.now()}`,
      );
      if (!mainConfigResponse.ok) {
        throw new Error("Не удалось загрузить список альбомов");
      }
      const mainConfig = await mainConfigResponse.json();

      const albumsWithConfigs = await Promise.all(
        mainConfig.albums.map(async (album) => {
          const folderConfigResponse = await fetch(
            `${ALBUM_URL}?folder=${encodeURIComponent(album.folder)}&v=${Date.now()}`,
          );
          if (!folderConfigResponse.ok) {
            return null;
          }
          const folderConfig = await folderConfigResponse.json();

          return {
            folder: album.folder,
            name: folderConfig.name,
            year: folderConfig.year || album.year,
            thumbnail: folderConfig.thumbnail,
            images: folderConfig.images,
            timestamp: folderConfig.timestamp || mainConfig.timestamp,
          };
        }),
      );

      // Фильтруем null значения (если были ошибки загрузки)
      const validAlbums = albumsWithConfigs.filter((album) => album !== null);
      setAlbums(validAlbums);
    } catch (err) {
      setError("Не удалось загрузить альбомы");
    } finally {
      setLoading(false);
    }
  }

  if (loading) {
    return <div className="loading">Загрузка...</div>;
  }

  if (error) {
    return <div className="error">{error}</div>;
  }

  function onClick() {
    scroll("services");
  }

  return (
    <div className="projects-wrapper" id="projects">
      <div className="projects-title">наши проекты</div>
      <div className="projects-cards">
        {albums.map((album, index) => (
          <ProjectCard
            key={`${album.folder}-${album.timestamp}`}
            folder={album.folder}
            name={album.name}
            year={album.year}
            thumbnail={album.thumbnail}
            images={album.images}
            timestamp={album.timestamp}
          />
        ))}
      </div>
      <Button colorScheme="white" onClick={onClick}>
        услуги
      </Button>
    </div>
  );
}
